import { Component, Input, OnInit } from '@angular/core';
import { UspCard } from '../../models';
import { USP_DEFAULT_CARDS, USP_IT_DISCLAIMER_LINK } from './usp-grid.constants';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { SafeHtml } from '@angular/platform-browser';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { CountryCode } from '~shared/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { GATrackingEventType, GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-usp-grid',
  templateUrl: './usp-grid.component.html',
  styleUrls: ['./usp-grid.component.scss'],
})
export class UspGridComponent implements OnInit {
  // cards coming from storyblok, empty for now
  @Input() cards: Array<UspCard>;
  // so we use these default config until we get the data from storyblok
  uspDefaultCards = USP_DEFAULT_CARDS;
  isMobile = false;
  market: string;

  readonly IT_MARKET = CountryCode.Italy;

  private unsubscribe$ = new Subject();

  constructor(private mediaObserver: MediaObserver, private gtmDatalayerService: GtmDatalayerService) {
    this.market = getCountryDomainCode();
  }

  ngOnInit(): void {
    this.initializeMediaObservable();
  }

  initializeUspGridView(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_BENEFITS_VIEWED,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.USP_BENEFITS_VIEWED,
    });
  }

  getDisclaimerText(introText: string, linkText: string, endingText: string): SafeHtml {
    const disclaimerLink = `<a href=${USP_IT_DISCLAIMER_LINK}>${linkText}</a>`;
    return `${introText} ${disclaimerLink} ${endingText}`;
  }

  private initializeMediaObservable(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
      });
  }
}
